export default "__VITE_ASSET__BFtUlF6x__"